import Vue from "vue"
import Vuex from "vuex"
import audit from "./modules/audit"
import createPersistedState from "vuex-persistedstate"
import loading from "./modules/loading"
import connections from "./modules/connections"
import user from "./modules/user"
import notifications from "./modules/notifications"

Vue.use(Vuex)

let persisted = createPersistedState({
	paths: ["audit", "audit.template", "connections", "connections.invitationcodes", "user", "selectedItem"]
})

export default new Vuex.Store({
	modules: {
		audit,
		loading,
		connections,
		user,
		notifications
	},
	strict: true,
	state: {
		selectedId: null,
		selectedTitle: "",
		selectedDescription: "",
		selectedStatus: "Active",
		selectedItem: {
			ID: null,
			Title: "",
			Description: "",
			Year: null,
			Status: "Active",
			Created: ""
		},
		selectedIndex: null,
		selectedNewstate: false,
		createMatrix: false,
	},
	mutations: {
		setSelectedId(state, id) {
			state.selectedId = id
		},
		setSelectedTitle(state, title) {
			state.selectedTitle = title
		},
		setSelectedDescription(state, description) {
			state.selectedDescription = description
		},
		setSelectedStatus(state, status) {
			state.selectedStatus = status
		},
		setSelectedItem(state, item) {
			state.selectedItem = item
		},
		setSelectedIndex(state, index) {
			state.selectedIndex = index
		},
		setSelectedNewstate(state, newstate) {
			state.selectedNewstate = newstate
		},
		setCreateMatrix(state, createMatrix) {
			state.createMatrix = createMatrix
		}
	},
	actions: {
		updateSelectedId({ commit }, id) {
			commit("setSelectedId", id)
		},
		updateSelectedTitle({ commit }, title) {
			commit("setSelectedTitle", title)
		},
		updateSelectedDescription({ commit }, description) {
			commit("setSelectedDescription", description)
		},
		updateSelectedStatus({ commit }, status) {
			commit("setSelectedStatus", status)
		},
		updateSelectedItem({ commit }, item) {
			commit("setSelectedItem", item)
		},
		updateSelectedIndex({ commit }, index) {
			commit("setSelectedIndex", index)
		},
		updateSelectedNewstate({ commit }, newstate) {
			commit("setSelectedNewstate", newstate)
		},
		updateCreateMatrix({ commit }, createMatrix) {
			commit("setCreateMatrix", createMatrix)
		}
	},
	getters: {
		selectedId: (state) => state.selectedId,
		selectedTitle: (state) => state.selectedTitle,
		selectedDescription: (state) => state.selectedDescription,
		selectedStatus: (state) => state.selectedStatus,
		selectedItem: (state) => state.selectedItem,
		selectedIndex: (state) => state.selectedIndex,
		selectedNewstate: (state) => state.selectedNewstate,
		createMatrix: (state) => state.createMatrix,
	},
	plugins: [persisted]
})